import React from 'react';
import PropTypes from 'prop-types';
import { convert2HtmlEntities } from './mdUtils';
import './NormalMd2React.scss';

const NormalMd2React = ({ content }) => <div>{content && convert2HtmlEntities(content)}</div>;

NormalMd2React.defaultProps = {
	content: '',
};

NormalMd2React.propTypes = {
	content: PropTypes.string,
};

export default NormalMd2React;
